/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';

import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import Render from 'components/render';
import {
  IS_INDIAN_EXCHANGE,
  IS_RN_WEBVIEW,
  IS_RN_WEBVIEW_ANDROID,
  OAUTH_CANCEL_CODE,
} from 'constants/constants';
import { OAUTH_PROVIDERS } from 'constants/enums';
import { FEATURE_FLAG_OAUTH_ENABLED } from 'constants/rnApp';
import { isAndroidDevice, noop } from 'helpers/utils';
import { useOAuthLogin } from 'hooks/useOAuthLogin';
import Box from 'UIKit/Box';

import AppleButton from './AppleButton';
import GoogleButton from './GoogleButton';
import { OAuthSignInButtonsProps, OAuthSuccessFunctionProps } from './interface';
import classes from './oauth.module.scss';

const OAuthSignInButtons = ({
  handleOAuthSignInSuccess = noop,
  errorMessage,
  provider,
  disableButton = false,
  loading = false,
  onClickOAuthButton = noop,
  page = 'login',
}: OAuthSignInButtonsProps) => {
  const { status, data, error, provider: oAuthLoginProvider } = useOAuthLogin();
  const [errorMsg, setErrorMsg] = useState<string | React.ReactNode>('');
  const { t } = useTranslation(['errors', 'auth']);

  const hideOAuthButton = IS_RN_WEBVIEW && !FEATURE_FLAG_OAUTH_ENABLED;

  useEffect(() => {
    setErrorMsg(errorMessage);
  }, [errorMessage]);

  useEffect(() => {
    if (IS_RN_WEBVIEW) {
      if (status === 'success') {
        const payload = {
          accessToken: data?.accessToken,
          provider: OAUTH_PROVIDERS.GOOGLE,
        } as OAuthSuccessFunctionProps;

        if (oAuthLoginProvider === OAUTH_PROVIDERS.APPLE) {
          payload.accessToken = data?.authorizationCode as string;
          payload.provider = OAUTH_PROVIDERS.APPLE;
          payload.redirectURI = window.location.href;
          payload.idToken = data?.identityToken;
        }

        handleOAuthSignInSuccess(payload);
      } else if (
        (status === 'failed' || error?.code === 'PLAY_SERVICES_NOT_AVAILABLE') &&
        error !== OAUTH_CANCEL_CODE
      ) {
        setErrorMsg(t('errors:defaultMessage'));
      }
    }
  }, [status]);

  const handleClickOAuthButton = prov => {
    setErrorMsg('');
    onClickOAuthButton(prov);
  };

  return (
    <Box renderWhen={!hideOAuthButton} className={classes.container}>
      <Box
        className={cx(classes.topText, {
          [classes.textCenterAlign]: !IS_INDIAN_EXCHANGE,
        })}
        renderWhen={page === 'signup'}
      >
        {t('auth:signUpWith')}
      </Box>
      <Box className={classes.oauthButtons}>
        <GoogleButton
          disableButton={disableButton}
          provider={provider}
          errorMessage={errorMsg}
          handleOAuthSignInSuccess={handleOAuthSignInSuccess}
          onClickOAuthButton={handleClickOAuthButton}
          loading={loading}
        />
        <Render when={!IS_RN_WEBVIEW_ANDROID && !isAndroidDevice()}>
          <AppleButton
            disableButton={disableButton}
            provider={provider}
            errorMessage={errorMsg}
            handleOAuthSignInSuccess={handleOAuthSignInSuccess}
            onClickOAuthButton={handleClickOAuthButton}
            loading={loading}
          />
        </Render>
      </Box>
      <div className={classes.divider} data-before={t('auth:or')} />
    </Box>
  );
};

OAuthSignInButtons.displayName = 'OAuthSignIn';

export default OAuthSignInButtons;
